import { render, staticRenderFns } from "./PinRequest.vue?vue&type=template&id=0ed95140&lang=pug&"
import script from "./PinRequest.vue?vue&type=script&lang=ts&"
export * from "./PinRequest.vue?vue&type=script&lang=ts&"
import style0 from "./PinRequest.vue?vue&type=style&index=0&id=0ed95140&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports